export default {
  title: {
    'zh-cn': '资源列表',
    'zh-tw': '資源列表',
    'en': 'Resource List'
  },
  upload: {
    'zh-cn': '上传',
    'zh-tw': '上傳',
    'en': 'Upload'
  },
  packageType: {
    'zh-cn': '升级包类型',
    'zh-tw': '升級包類型',
    'en': 'Package Type'
  },
  packageTypeApp: {
    'zh-cn': '组合包(APP+固件)',
    'zh-tw': '組合包(APP+固件)',
    'en': 'Combined Package (APP+Firmware)'
  },
  packageTypeFirmware: {
    'zh-cn': '固件升级包',
    'zh-tw': '固件升級包',
    'en': 'Firmware Package'
  },
  packageTypeCustom: {
    'zh-cn': '二开升级包',
    'zh-tw': '二開升級包',
    'en': 'Custom Package'
  },
  applicableDevice: {
    'zh-cn': '适用设备',
    'zh-tw': '適用設備',
    'en': 'Applicable Device'
  },
  version: {
    'zh-cn': '版本号',
    'zh-tw': '版本號',
    'en': 'Version'
  },
  appVersion: {
    'zh-cn': 'APP版本号',
    'zh-tw': 'APP版本號',
    'en': 'APP Version'
  },
  firmwareVersion: {
    'zh-cn': '固件版本号',
    'zh-tw': '固件版本號',
    'en': 'Firmware Version'
  },
  packageDescription: {
    'zh-cn': '升级包描述',
    'zh-tw': '升級包描述',
    'en': 'Package Description'
  },
  packageEnable: {
    'zh-cn': '是否启用升级包',
    'zh-tw': '是否啟用升級包',
    'en': 'Enable Package'
  },
  packageEnableTip: {
    'zh-cn': '关闭升级包将不可选择和下载， 只展示描述',
    'zh-tw': '關閉升級包將不可選擇和下載， 只展示描述',
    'en': 'Disabling the package will make it unselectable and undownloadable, only description will be shown'
  },
  uploadTip: {
    'zh-cn': '点击或拖拽文件到此处上传',
    'zh-tw': '點擊或拖拽文件到此處上傳',
    'en': 'Click or drag file here to upload'
  },
  uploadTipSub: {
    'zh-cn': '文件大小控制在{max}M以内',
    'zh-tw': '文件大小控制在{max}M以內',
    'en': 'File size must be within {max}M'
  },
  editPackage: {
    'zh-cn': '升级包修改',
    'zh-tw': '升級包修改',
    'en': 'Edit Package'
  },
  addPackage: {
    'zh-cn': '上传升级包',
    'zh-tw': '上傳升級包',
    'en': 'Upload Package'
  },
  addSuccess: {
    'zh-cn': '添加成功',
    'zh-tw': '添加成功',
    'en': 'Add successful'
  },
  updateSuccess: {
    'zh-cn': '修改成功',
    'zh-tw': '修改成功',
    'en': 'Update successful'
  },
  uploadFailed: {
    'zh-cn': '上传包文件失败',
    'zh-tw': '上傳包文件失敗',
    'en': 'Upload package file failed'
  },
  fileSizeError: {
    'zh-cn': '请上传小于{max}M 的文件',
    'zh-tw': '請上傳小於{max}M 的文件',
    'en': 'Please upload a file smaller than {max}M'
  }
}

